export default "__VITE_ASSET__BT3AP7jj__"